export default __webpack_public_path__ + "static/media/DSC_0277.82b65ce4.jpg";